import { Deserializable } from '../../../protocols/deserializable';
import { IpUserSubmissionType } from './ip-user-submission-type';

export class IpUserSubmissionPermissionResponse implements Deserializable {
  memberSubmissionTypes: IpUserSubmissionType[] = [];
  employerSubmissionTypes: IpUserSubmissionType[] = [];

  onDeserialize() {}
}
